import React, { Component } from 'react';
import { connect } from "react-redux";
import {hashHistory} from "react-router";
import {FormattedMessage} from "react-intl";

import { toggleBathroomVisualizerOpen } from '../../actions/actionFunctions';
import {getCurrentLayout} from "../appLayout";
import DesktopHeader from '../desktopHeader';
import ProjectScopeSections from "./projectScopeSections";
import ProjectScopeDesktopSearchInput from './projectScopeDesktopSearchInput';
import Analytics from './../../analytics';

class ProjectScopeDesktop extends Component {

  componentDidMount() {
    document.body.classList.remove('body--materials');
  }

  goToVisualizer = () => {
    Analytics.sendClickEvent('go-to-visualizer');
    this.props.toggleBathroomVisualizerOpen(true);
    hashHistory.push('visualizer');
  };

  getVisualizerName = () => {
    switch (document.kvConfig.visualizerType) {
      case "Kitchen":
      case "KV":
        return "Kitchen";
      case "Bathroom":
      case "BV":
        return "Bathroom";
      default:
        return "";
    }
  };

  render() {
    const layout = getCurrentLayout();
    return (
      <div className="base-qt homepage">
        <DesktopHeader uploadsAndNotes={false}/>
        <div className="main">
          <section className={"intro intro--" + this.getVisualizerName().toLowerCase()}>
            <div className="intro-text">
              <h1 className="h1 intro-text__h1">
                <FormattedMessage id={"projectScope.bannerTitle"}/>
                <span className="h1-strong">
                  <FormattedMessage id={"projectScope.bannerVisualizerName"+this.getVisualizerName()}/>
                </span>
              </h1>
              <h3 className="h3 intro-text__h3"><FormattedMessage id={"projectScope.bannerText"}/></h3>
              <button className="ui-button2 ui-button2--green intro-text__button"
                      onClick={this.goToVisualizer}>
                <FormattedMessage id={"projectScope.bannerButton"}/>
              </button>
            </div>
          </section>
          <ProjectScopeDesktopSearchInput layout={layout}/>
          <ProjectScopeSections/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return {

  };
};

export default connect(mapStateToProps, {
  toggleBathroomVisualizerOpen
})(ProjectScopeDesktop);
